import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AxiosError } from "axios"
import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxInputPassword from "src/components/input/SfxInputPassword.vue"
import { useAuthStore } from "src/stores/authStore"
import { Log } from "src/util/classes/log"
import { hashPassword } from "src/util/functions/hashing"
import { showErrorNotification, showSuccessNotification } from "src/util/functions/notifications"
import { getPasswordRequirements, isIncorrectPassword } from "src/util/functions/user"
import { patchChangePassword } from "src/util/http/springboard/user"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogChangePassword',
  setup(__props) {

const { t } = useI18n()
const authStore = useAuthStore()
const { dialogRef, onDialogCancel, onDialogOK } = useDialogPluginComponent()
const currentPassword = ref("")
const newPassword = ref("")
const repeatNewPassword = ref("")
const errorMessage = t("sfxDialogChangePassword.password_mismatch")

const validDateRule = computed(() => getPasswordRequirements(currentPassword.value))

//endregion

//region Functions

async function setNewPassword() {
  if (newPassword.value === repeatNewPassword.value) {
    try {
      const hashResult = await hashPassword(newPassword.value)
      if (hashResult) {
        authStore.setNewPasswordHashed(hashResult)
      } else {
        Log.error({ message: "Failed to hash password." })
      }
    } catch (error) {
      Log.error({ message: "Failed to set new password.", error })
    }
  }
}

async function updatePassword() {
  try {
    await patchChangePassword(
      {},
      {
        current_password: currentPassword.value,
        password: newPassword.value,
      }
    )
    showSuccessNotification(t("sfxDialogChangePassword.password_changed"))
    onDialogOK()
  } catch (error: unknown) {
    if (error instanceof AxiosError && isIncorrectPassword(error)) {
      return showErrorNotification(t("sfxDialogChangePassword.password_incorrect"))
    }
    showErrorNotification(t("sfxErrorMsg.error_change_password"))
    Log.error({ message: "An error occurred while trying to update the password", error })
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-change-password"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-px-lg q-py-md" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogChangePassword.title_change_password")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_form, { onSubmit: updatePassword }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "text-caption text-italic text-field-label q-px-lg q-pt-none" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogChangePassword.password_requirements")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-px-lg q-pt-none q-gutter-sm" }, {
                default: _withCtx(() => [
                  _createVNode(SfxInputPassword, {
                    modelValue: currentPassword.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
                    label: _ctx.$t('sfxDialogChangePassword.input_current_password'),
                    autocomplete: "current-password"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(SfxInputPassword, {
                    modelValue: newPassword.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
                    label: _ctx.$t('sfxDialogChangePassword.input_new_password'),
                    "lazy-rules": "",
                    rules: validDateRule.value,
                    autocomplete: "new-password"
                  }, null, 8, ["modelValue", "label", "rules"]),
                  _createVNode(SfxInputPassword, {
                    modelValue: repeatNewPassword.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatNewPassword).value = $event)),
                    label: _ctx.$t('sfxDialogChangePassword.input_repetition'),
                    "lazy-rules": "",
                    rules: [(value) => value === newPassword.value || _unref(errorMessage)],
                    "error-message": _unref(errorMessage),
                    autocomplete: "new-password"
                  }, null, 8, ["modelValue", "label", "rules", "error-message"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { class: "q-px-lg q-pt-md q-mt-lg" }, {
                default: _withCtx(() => [
                  _createVNode(SfxBtnOutline, {
                    class: "col",
                    label: _ctx.$t('sfxButtons.btn_cancel'),
                    onClick: _unref(onDialogCancel)
                  }, null, 8, ["label", "onClick"]),
                  _createVNode(SfxBtn, {
                    class: "col",
                    label: _ctx.$t('sfxButtons.btn_save'),
                    disable: !currentPassword.value || !newPassword.value || !repeatNewPassword.value,
                    type: "submit",
                    onClick: setNewPassword
                  }, null, 8, ["label", "disable"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})